<script setup lang="ts">
import ButtonIconOnly from '@/components/atoms/ButtonIconOnly.vue'
import type { Question } from '../calendarQuestion'
import CalendarQuestionSample from './CalendarQuestionSample.vue'
import IconChevron from '@/components/icons/IconChevron.vue'
import IconTrash from '@/components/icons/IconTrash.vue'

const { question, isSelected, formError } = defineProps<{
  question: Question
  isSelected: boolean
  formError: string | undefined
}>()

const emit = defineEmits<{
  (event: 'select' | 'up' | 'down' | 'remove'): void
}>()
</script>

<template>
  <div
    :class="[$style.question, { [$style['question--selected']]: isSelected }]"
  >
    <div :class="$style.upDownControl">
      <ButtonIconOnly
        :class="$style.upDownControl__button"
        @click.prevent="emit('up')"
      >
        <template #icon><IconChevron direction="up" /></template>
      </ButtonIconOnly>
      <ButtonIconOnly
        :class="$style.upDownControl__button"
        @click.prevent="emit('down')"
      >
        <template #icon> <IconChevron direction="down" /> </template>
      </ButtonIconOnly>
    </div>
    <CalendarQuestionSample
      @click.prevent="emit('select')"
      :class="[$style.sample, { [$style['sample--selected']]: isSelected }]"
      :question="question"
      :formError="formError"
    />
    <div :class="$style.removeControl">
      <ButtonIconOnly
        :class="$style.removeControl__button"
        @click.prevent="emit('remove')"
      >
        <template #icon> <IconTrash /> </template>
      </ButtonIconOnly>
    </div>
  </div>
</template>

<style lang="scss" module>
.question {
  transition: $transition-base;
  padding: 16px;
  display: flex;
  gap: 16px;

  &--selected {
    background-color: $color-surface-accent-primary-light;
  }

  &:hover {
    background-color: $color-surface-accent-primary-light;
  }
}

.upDownControl {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  gap: 8px;
}

.removeControl {
  display: flex;
  align-items: center;
  justify-content: center;

  &__button {
    color: $color-text-and-object-accent-red;

    svg {
      width: 24px;
      height: 24px;
    }
  }
}

.sample {
  flex: 1;
  cursor: pointer;

  & * {
    cursor: pointer;
  }

  &--selected {
    cursor: default;

    & * {
      cursor: default;
    }
  }
}
</style>
